// //API URL for Local & QA
// // const baseUrl = "http://44.205.102.108/qa/api/";
// // API URL for AWS Staging
// // const baseUrl = "http://44.198.199.173/staging/api/";npm
// // API URL for AWS Production for WinSCP Host Name (3.221.217.242)
// // const baseUrl = "https://splitpos.com:8080/api/";

import axios from "axios";
import { getUserToken } from "./utils";
export const itemsPerPage = 10;
// 1. Create the Instance (Reviewer's Fix)
const apiClient = axios.create({
  baseURL: "https://splitpos.com:8080/api/" || "",
  // baseURL: "http://44.205.102.108/qa/api/" || "",
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 2. Request Interceptor: Handles Authorization for ALL requests automatically
apiClient.interceptors.request.use((config) => {
  const tokenData = getUserToken();
  try {
    const apitoken = tokenData ? JSON.parse(tokenData) : null;
    if (apitoken) {
      config.headers.Authorization = `Bearer ${apitoken}`;
    }
  } catch (error) {
    console.error("Token parsing failed", error);
  }
  return config;
});

const handleInvalidToken = (navigate) => {
  localStorage.clear();
  if (navigate) navigate("/sign-in");
  else window.location.href = "/sign-in";
};

// 3. Response Interceptor: Replaces your old setupInterceptors
export const setupInterceptors = (navigate) => {
  apiClient.interceptors.response.use(
    (response) => {
      if (response?.data?.message === "Invalid token!") {
        handleInvalidToken(navigate);
      }
      return response;
    },
    (error) => {
      const status = error.response?.status;
      const msg = error?.response?.data?.message;
      if (
        status === 401 ||
        msg === "Invalid token!" ||
        msg === "Unauthorized access token!"
      ) {
        handleInvalidToken(navigate);
      }
      return Promise.reject(error);
    },
  );
};

// --- CLEANED API METHODS ---

// POST
export const postReq = (apiPath, reqBody) => {
  return apiClient.post(apiPath, reqBody);
};

export const postReqWithFile = (apiPath, reqBody) => {
  return apiClient.post(apiPath, reqBody, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const postReqForOnlineForm = (apiPath, reqBody) => {
  return apiClient.post(apiPath, reqBody, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const postReqwithoutHeader = (apiPath, reqBody) => {
  return apiClient.post(apiPath, reqBody, {
    headers: { Authorization: "" }, // Overrides interceptor if header-less is truly required
  });
};

// GET
export const getReq = (apiPath) => {
  return apiClient.get(apiPath);
};

export const getById = (apiPath, id) => {
  return apiClient.get(apiPath, {
    params: { agentId: id }, // Use params for cleaner GET requests
  });
};

// PUT
export const putReq = (apiPath, reqBody) => {
  return apiClient.put(apiPath, reqBody);
};

export const putReqForEmp = (apiPath, reqBody) => {
  return apiClient.put(apiPath, reqBody, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// DELETE
export const delWithBodyReq = (apiPath, reqBody) => {
  return apiClient.delete(apiPath, { data: reqBody });
};

export const delReq = (apiPath, id, role) => {
  const roleMap = {
    department: "departmentId",
    flag: "flagId",
    payout: "payoutId",
    product: "itemId",
    promotion: "promotionId",
    combinedPromotion: "combinedPromotionId",
    customer: "customerId",
    customerGroup: "customerGroupId",
    selectedItems: "selectedItems",
    empTask: "taskId",
  };

  const idKey = roleMap[role];
  return apiClient.delete(apiPath, {
    data: idKey ? { [idKey]: id } : {},
  });
};
